{
  "bug": {
    "report": "Report a problem",
    "title": "Report a problem",
    "intro": "Tell us what went wrong. We'll capture a screenshot and your recent activity to help us reproduce it.",
    "describeLabel": "What happened?",
    "placeholder": "Step by step: 1) what you did, 2) what you expected, 3) what actually happened.",
    "submit": "Send report",
    "sent": "Thanks — your report was sent."
  },
  "stepper": {
    "label": "Step {{current}} of {{total}}",
    "completed": "completed",
    "current": "current",
    "upcoming": "not started",
    "stepState": "Step {{current}} of {{total}}, {{state}}"
  },
  "breadcrumbs": {
    "label": "Breadcrumb"
  },
  "common": {
    "back": "Back",
    "loading": "Loading…",
    "loadingFormats": "Loading formats…",
    "cancel": "Cancel",
    "create": "Create",
    "clone": "Clone",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "download": "Download",
    "search": "Search",
    "clearFilters": "Clear filters",
    "prev": "← Prev",
    "next": "Next →",
    "any": "Any",
    "apiHint": "The catalog comes from the backend — make sure the API is running.",
    "startOver": "Start over",
    "page": "Page {{page}} of {{total}}",
    "save": "Save",
    "rename": "Rename"
  },
  "language": {
    "label": "Language",
    "en": "EN",
    "es": "ES",
    "english": "English",
    "spanish": "Español",
    "changed": "Language changed.",
    "saveFailed": "Could not save your language preference."
  },
  "theme": {
    "label": "Color theme",
    "system": "System theme",
    "light": "Light theme",
    "dark": "Dark theme"
  },
  "comfort": {
    "label": "Text size",
    "toggle": "Larger text",
    "on": "Larger",
    "off": "Normal"
  },
  "create": {
    "title": "Create a new EDD format",
    "subtitle": "How would you like to build it?",
    "aiTitle": "Build it with AI",
    "aiBody": "Tell our helper, in your own words, what file you need. It asks a few simple questions, then fills everything in for you to check.",
    "manualTitle": "Set it up myself",
    "manualBody": "Start from a blank format and fill in the settings, columns, and rules yourself in the editor.",
    "recommended": "Recommended",
    "chatSubtitle": "Tell me what you need. You can type or tap the microphone and talk.",
    "switchManual": "Do it myself instead",
    "placeholder": "For example: a CSV file for NYSDEC with a header row…",
    "send": "Send",
    "openEditor": "Open in the editor to review",
    "chatPanelLabel": "AI chat",
    "draftPaneTitle": "Your EDD so far",
    "draftEmpty": "Tell me about the file you need on the right — your EDD takes shape here as we chat.",
    "draftUnnamed": "Untitled EDD",
    "draftColumns": "{{count}} columns",
    "draftSampleCols": "Columns",
    "draftQcCols": "QC columns",
    "draftTransforms": "Calculations & rules ({{count}})",
    "draftCrossTables": "Value translations ({{count}})",
    "draftReadyHint": "Looks right? Open it in the editor to preview with your data and finish.",
    "setupTitle": "Before we start (optional)",
    "setupSubtitle": "Give me an example or some formats to learn from — or just skip this and tell me what you need.",
    "filesTitle": "Upload your files",
    "filesHint": "Have an example of the file you send, a written specification, or any reference document? Add one or more and I'll use them. Don't have any? That's fine — just skip this and tell me what you need.",
    "filesDrop": "Drop a file here, or click to choose (CSV, text, spec, document…)",
    "attachmentsTitle": "Your files",
    "attachmentsEmpty": "No files yet. Drop one below and I'll use it.",
    "addFile": "Add a file",
    "removeFile": "Remove",
    "existingTitle": "You may already have this",
    "existingBody": "I found a format that looks like a strong match — {{name}} ({{pct}}% match). You could use it as-is instead of building a new one.",
    "exampleTitle": "Do you have an example of the file you send?",
    "exampleHint": "Upload one and I'll use its columns exactly. Most people don't have one — that's fine, just skip it.",
    "exampleDrop": "Drop an example file here (CSV)",
    "refTitle": "Start from existing formats",
    "refHint": "Pick one or more of your formats to use as a starting point. Leave empty to start from scratch.",
    "startBuilding": "Start building",
    "checkingFile": "Checking your file…",
    "instructionsTitle": "Anything I should know? (optional)",
    "instructionsHint": "Add any context in your own words — who this is for, special rules, columns you need. You can type or tap the microphone and talk.",
    "instructionsPlaceholder": "For example: it's for MDEQ, dates must be MM/DD/YYYY, and I need a separate flags column…"
  },
  "filePool": {
    "title": "What I received",
    "intro": "Here's what I made of each file. If I got one wrong, remove it or tell me what it's for.",
    "listLabel": "Uploaded files and what I think they are",
    "unnamed": "Unnamed file",
    "remove": "Remove",
    "unknownHint": "⚠ I'm not sure what this is — remove it, or tell me what it's for.",
    "roles": {
      "sample_results": "Sample results",
      "qc_results": "Quality-control results",
      "client_spec": "Client / regulator specification",
      "cross_table_workbook": "Cross-table workbook",
      "known_good_output": "A finished EDD to reproduce",
      "reference_template": "A reference template",
      "unknown": "Unrecognized file"
    }
  },
  "nav": {
    "brand": "Prisma EDD Builder",
    "home": "Home",
    "account": "Account",
    "menu": "Menu",
    "createEddFile": "Create EDD file",
    "createEddTemplate": "Create a new EDD template",
    "createDeliverable": "Create a deliverable",
    "createEdd": "Create a new EDD",
    "history": "History",
    "formats": "Your EDD Formats",
    "standards": "Standards",
    "team": "Team",
    "connector": "Connector",
    "advanced": "Advanced",
    "formatLibrary": "Format library",
    "combineFormats": "Combine formats",
    "buildWithAi": "Build with AI",
    "multipleWorkOrders": "Multiple work orders",
    "gettingStarted": "Getting Started",
    "savedFormats": "Your saved formats",
    "templates": "Format library",
    "configs": "EDD Formats",
    "aiDraft": "Build a format with AI",
    "merge": "Combine formats",
    "generate": "Create a deliverable",
    "batch": "Multiple work orders",
    "jobs": "History",
    "specs": "Standards",
    "workers": "Windows connector",
    "admin": "Team",
    "profile": "Profile",
    "setup": "Set up / import",
    "logout": "Log out",
    "groupPrimary": "Main",
    "groupAdmin": "Admin",
    "codeBooks": "Cross-tables"
  },
  "glossary": {
    "title": "Plain-English guide",
    "edd": {
      "term": "EDD",
      "definition": "An EDD is a file you send to a regulator or client with your lab results. Think of it like a report card for water or soil samples — but in a specific format the receiver requires."
    },
    "template": {
      "term": "Template",
      "definition": "A template is like a recipe. It tells the system exactly how to arrange your data — which columns, what order, what format — so the file comes out exactly right for whoever needs it."
    },
    "engine": {
      "term": "Engine",
      "definition": "An engine is the set of rules that builds the EDD file. It knows things like 'if the result is below the detection limit, write <MDL instead of the number.'"
    },
    "crosstable": {
      "term": "Cross-table / Valid Values",
      "definition": "A cross-table is a translator. Your lab calls something 'Mercury' but the state wants '7439-97-6'. The cross-table does that translation automatically."
    },
    "transform": {
      "term": "Transform",
      "definition": "A transform is a rule that changes data before it goes into the file. For example: 'If the result is less than the MDL, put a U flag in the qualifier column.'"
    },
    "fieldMapping": {
      "term": "Field Mapping",
      "definition": "A field mapping tells the system where to get each piece of data. It connects your lab's data fields to the columns the regulator wants."
    }
  },
  "location": {
    "label": "Current location",
    "none": "No location",
    "loading": "Loading…",
    "default": "Default",
    "add": "+ Add location",
    "addTitle": "Add a location",
    "create": "Create location",
    "nameLabel": "Location name",
    "namePlaceholder": "e.g. Houston Lab",
    "codeLabel": "Code (optional)",
    "codeHint": "A short identifier for this location, e.g. HOU.",
    "codePlaceholder": "e.g. HOU",
    "added": "Location \"{{name}}\" added"
  },
  "formats": {
    "title": "All your EDDs",
    "subtitle": "Your own custom EDDs, the standard EDD library, and any site-custom formats — all in one place.",
    "subtitleAt": "Every EDD you can use at {{location}} — your custom EDDs plus the standard library.",
    "matchingFormats": "Total EDDs",
    "count": "{{count}} EDDs",
    "builtInNote": "The standard library is built into Prisma EDD Builder — upload this location's EDDBuilderData.mdb to add your own custom EDDs.",
    "helpTitle": "ℹ️ New here? What's an EDD?",
    "searchLabel": "Search",
    "searchPlaceholder": "Search EDDs by name…",
    "filterType": "Type",
    "allTypes": "All types",
    "filterSource": "Source",
    "allSources": "All sources",
    "filterFamily": "Category",
    "allFamilies": "All categories",
    "source": {
      "standard": "Standard",
      "governmental": "Governmental",
      "lab": "Your lab"
    },
    "type": {
      "custom": "Custom",
      "standard": "Standard",
      "site_custom": "Site-Custom"
    },
    "statusChip": {
      "ready": "Ready to use",
      "needs_crosstable": "Needs cross-table setup",
      "preview_only": "Preview only"
    },
    "noMatchTitle": "No EDDs match",
    "noMatchBody": "Try clearing the search or filters.",
    "fields": "{{count}} fields",
    "openEditor": "Open in editor →",
    "useThisFormat": "Use this format →",
    "uploadTitle": "Add this location's custom EDDs",
    "uploadBody": "Upload your EDDBuilderData.mdb to import your own EDDs.",
    "uploadBodyAt": "Upload {{location}}'s EDDBuilderData.mdb to import its own EDDs.",
    "dropTitle": "Drag your EDDBuilderData.mdb here",
    "dropBody": "or click to browse — .mdb files only",
    "uploading": "Uploading…",
    "chooseMdb": "Please choose an .mdb file.",
    "uploaded": "Imported {{name}}"
  },
  "home": {
    "greeting": "Hi {{name}}",
    "techSubtitle": "Make the file you send to your client or regulator.",
    "adminSubtitle": "Make a deliverable, or set up and run your lab.",
    "createTitle": "Create a deliverable",
    "generateTitle": "Generate an EDD",
    "createBody": "Pick your lab's format, add your work-order export, and we'll check it before you send.",
    "createCta": "Start",
    "generateCta": "Generate an EDD",
    "recentTitle": "Recent deliverables",
    "recentEmptyTitle": "No deliverables yet",
    "recentEmptyBody": "Create your first one and it will show up here for one-click re-download.",
    "recentError": "We couldn't load your recent deliverables. Check your connection and try again.",
    "viewAll": "See all history",
    "reDownload": "Download again",
    "noResultYet": "No file to download",
    "adminToolsTitle": "Set up & run your lab",
    "cardFormatsTitle": "EDD Formats",
    "cardFormatsBody": "View and edit your lab's saved EDD formats.",
    "cardStandardsTitle": "Standards",
    "cardStandardsBody": "Manage the regulator standards you check against.",
    "cardTeamTitle": "Team",
    "cardTeamBody": "Manage who can use Prisma EDD Builder at your lab.",
    "cardConnectorTitle": "Windows connector",
    "cardConnectorBody": "Connect the Windows helper for Promium write-back.",
    "firstRunTitle": "First time? Import your existing EDD formats",
    "firstRunBody": "Bring your formats over from the legacy EDD Builder app. Upload your EDDBuilderData.mdb and we'll import every format for you.",
    "firstRunCta": "Import my formats"
  },
  "onboarding": {
    "title": "Welcome! Let's set up {{location}}",
    "subtitle": "We'll bring your lab's custom EDD formats over from your Promium computer. It only takes a minute, and you won't need any computer skills.",
    "step1Label": "What you need",
    "step2Label": "Upload",
    "step3Label": "Done",
    "explainTitle": "What we're going to do",
    "explainBody": "Your lab already has its EDD formats set up in the old Promium / Element \"EDD Builder\" program. We just need a few files from that computer so the same formats show up here for you.",
    "whereTitle": "Where the files live",
    "whereBody": "On the Windows computer that runs Promium / Element, open the EDD Builder install folder. It's usually here:",
    "filesTitle": "The files to look for",
    "fileMdb": "Your lab's custom EDD formats — this is the important one.",
    "fileEddlib": "The standard format library (we already have this built in).",
    "fileEddcustom": "Any extra customizations made just for your lab.",
    "required": "Required",
    "optional": "Optional",
    "namingHint": "The file names are exactly EDDBuilderData.mdb, eddlib.dll and eddcustom.dll. If you don't see them, ask whoever installed Promium where the EDD Builder folder is.",
    "startUpload": "Next: upload the files",
    "uploadTitle": "Drop your files here",
    "uploadBody": "Drag all of the files you found onto the box below at once — or click to browse for them. You can include the .mdb and the .dll files together.",
    "dropTitle": "Drag your Promium files here",
    "dropBrowse": "or click to browse",
    "dropAria": "Upload your Promium EDD Builder files",
    "uploading": "Setting up your formats…",
    "needMdb": "Please include your EDDBuilderData.mdb file — that's the one with your formats.",
    "noRecognizedFiles": "None of those files are recognized. Drop the EDDBuilderData.mdb (and optionally the .dll files) from your Promium install folder.",
    "fileTooLarge": "\"{{name}}\" is too large to upload here ({{size}} MB; limit {{limit}} MB). It may be the wrong file — the configuration database is usually a few MB.",
    "dllAck": "Got it — we received {{names}}. The standard format library is already built in, so we'll just keep these on file.",
    "libraryNote": "Good to know: the standard EDD library is already included. Your EDDBuilderData.mdb is what brings over the formats made just for your lab.",
    "back": "Back",
    "doneTitle_one": "All set — we set up {{count}} format for you",
    "doneTitle_other": "All set — we set up {{count}} formats for you",
    "doneBody": "Your formats are ready. You can start making the file you send to your client or regulator any time.",
    "summaryFormats_one": "{{count}} format imported",
    "summaryFormats_other": "{{count}} formats imported",
    "summaryEngines_one": "{{count}} custom format decoded from your eddcustom.dll ({{transforms}} rules recovered)",
    "summaryEngines_other": "{{count}} custom formats decoded from your eddcustom.dll ({{transforms}} rules recovered)",
    "summarySchemas": "Analysis schemas found: {{values}}",
    "verifyPassed": "All checks passed",
    "verifyFailedTitle": "Some checks need a second look",
    "goGenerate": "Generate an EDD",
    "goHome": "Go to home"
  },
  "email": {
    "title_one": "Email {{count}} deliverable",
    "title_other": "Email {{count}} deliverables",
    "intro_one": "We'll send the {{count}} deliverable you picked as an attachment.",
    "intro_other": "We'll send the {{count}} deliverables you picked as attachments.",
    "toLabel": "Send to",
    "toHint": "You can enter more than one — separate them with a comma or a space.",
    "toPlaceholder": "name@client.com, name@regulator.gov",
    "toInvalid": "Please enter at least one valid email address.",
    "subjectLabel": "Subject (optional)",
    "subjectPlaceholder": "Your EDD files",
    "messageLabel": "Message (optional)",
    "messagePlaceholder": "Add a short note for the recipient…",
    "send": "Send",
    "sent_one": "Sent to {{to}}.",
    "sent_other": "Sent {{count}} files to {{to}}.",
    "noFiles": "The selected deliverables don't have any files to send yet.",
    "notConfigured": "Email isn't set up yet. Ask your administrator to turn on email, then you'll be able to send deliverables straight from here. In the meantime, you can download the files and attach them yourself.",
    "selectAll": "Select all deliverables",
    "selectOne": "Select {{name}}",
    "selectionLabel": "Selected deliverables",
    "selectedCount_one": "{{count}} deliverable selected",
    "selectedCount_other": "{{count}} deliverables selected",
    "clearSelection": "Clear",
    "emailSelected": "Email selected"
  },
  "wizard": {
    "title": "Create a deliverable",
    "exit": "Cancel",
    "back": "Back",
    "next": "Next",
    "backTo": "Back to {{step}}",
    "nextTo": "Continue to {{step}}",
    "step1Label": "Format",
    "step2Label": "Your data",
    "step3Label": "Check",
    "step4Label": "Download",
    "step1Title": "Which deliverable?",
    "step1Body": "Choose one of your lab's saved formats.",
    "searchFormats": "Search your formats…",
    "noFormatsTitle": "No formats yet",
    "noFormatsBody": "Your lab has no saved formats. Add one from the format library to get started.",
    "goToLibrary": "Open the format library",
    "loadingFormats": "Loading your formats…",
    "loadFormatsErrorTitle": "Couldn't load your formats",
    "loadFormatsErrorBody": "We couldn't reach the server to list your saved formats. Check your connection and try again.",
    "retry": "Try again",
    "wrongFileType": "That file type isn't supported. Drop a .mdb export or a .zip of Out*.csv files.",
    "schemaLabel": "Data schema",
    "schemaHint": "Choose the analysis schema this work order uses.",
    "step2Title": "Add your work-order data",
    "step2Body": "Drop the export you got from Element or Promium.",
    "dropTitle": "Drag your Element/Promium export (.mdb) here",
    "dropBrowse": "or browse",
    "dropZipHint": "Got a zip of Out*.csv files instead? Drop or browse for that too.",
    "uploadingFile": "Uploading…",
    "fileReady": "Using {{name}}",
    "changeFile": "Choose a different file",
    "sampleLink": "No file handy? Try with sample data (preview only)",
    "sampleSelected": "Using sample data — preview only, not for submission.",
    "useRealFile": "Use a real file instead",
    "step3Title": "We checked it",
    "checking": "Checking your deliverable…",
    "readyToSend": "✓ Ready to send",
    "readyBody": "Everything looks good. Continue to download your file.",
    "thingsToFix_one": "⚠ {{count}} thing to fix before you send",
    "thingsToFix_other": "⚠ {{count}} things to fix before you send",
    "fixBody": "Review the items below, then ask your QC manager to adjust the format if needed. You can still download to inspect.",
    "rowSummary": "{{sx}} sample results · {{qa}} QC results",
    "checkFailed": "We couldn't finish the check.",
    "step4Title": "Download",
    "step4ReadyBody": "Your deliverable is ready.",
    "downloadFile": "Download",
    "whatNext": "Attach this file to your submission to your client or regulator.",
    "createAnother": "Create another",
    "pickFormatFirst": "Choose a format to continue.",
    "addDataFirst": "Add your data to continue."
  },
  "auth": {
    "appName": "Prisma EDD Builder",
    "signInSubtitle": "Sign in to build your Electronic Data Deliverables.",
    "email": "Email",
    "emailPlaceholder": "you@lab.com",
    "password": "Password",
    "passwordPlaceholder": "••••••••",
    "signIn": "Sign in",
    "forgotPassword": "Forgot password?",
    "noAccount": "No account?",
    "createOne": "Create one",
    "signedIn": "Signed in.",
    "createTitle": "Create your account",
    "createSubtitle": "Start building EDD formats for your lab.",
    "newPasswordPlaceholder": "At least 8 characters",
    "passwordHint": "At least 8 characters.",
    "orgName": "Organization name (optional)",
    "orgNamePlaceholder": "Acme Environmental Lab",
    "orgNameHint": "Leave blank to create a personal organization.",
    "createAccount": "Create account",
    "accountCreated": "Account created.",
    "haveAccount": "Already have an account?"
  },
  "setPassword": {
    "title": "Set your new password",
    "subtitle": "Your account was created with a temporary password. Choose a new one to finish signing in.",
    "newPassword": "New password",
    "confirmPassword": "Confirm new password",
    "mismatch": "Those passwords don't match.",
    "submit": "Set password & continue"
  },
  "forgotPassword": {
    "title": "Reset your password",
    "subtitle": "Enter your email and we'll send you a link to reset your password.",
    "submit": "Send reset link",
    "sent": "If that email has an account, we've sent a reset link.",
    "backToLogin": "Back to sign in"
  },
  "resetPassword": {
    "title": "Choose a new password",
    "subtitle": "Enter a new password for your account.",
    "newPassword": "New password",
    "confirmPassword": "Confirm new password",
    "mismatch": "Those passwords don't match.",
    "submit": "Reset password",
    "success": "Your password has been reset. Please sign in.",
    "invalidLink": "This reset link is invalid or has expired.",
    "requestNew": "Request a new reset link"
  },
  "footer": {
    "copyright": "© 2026 Prisma EDD Builder"
  },
  "templates": {
    "title": "Format library",
    "subtitle": "All 196 standard EDD formats — 35 starter formats + 161 Standard-Library formats. Add any to your lab's formats.",
    "formats_one": "{{count}} format",
    "formats_other": "{{count}} formats",
    "matchingFormats": "Matching formats",
    "searchPlaceholder": "Name, class, or system…",
    "family": "Family",
    "allFamilies": "All families",
    "output": "Output",
    "allOutputs": "All outputs",
    "recoverability": "Recoverability",
    "testStatus": "Test status",
    "allKinds": "All kinds",
    "configTemplates": "Config templates",
    "standardLibrary": "Standard library",
    "inMyMdb": "In my uploaded .mdb",
    "noMatchTitle": "No formats match",
    "noMatchBody": "Try a broader search or clear the filters.",
    "hasConfig": "config",
    "fields_one": "{{count}} field",
    "fields_other": "{{count}} fields"
  },
  "configs": {
    "title": "EDD Formats",
    "subtitle": "Your lab's editable EDD formats.",
    "newFromDescription": "New from description",
    "newConfig": "+ New format",
    "colName": "Name",
    "colFormat": "Output",
    "colFields": "Columns",
    "colVersion": "Version",
    "colUpdated": "Updated",
    "querydefTitle": "Stored as a Jet QueryDef — read-only",
    "querydef": "querydef",
    "created": "Format created.",
    "cloned": "Format cloned.",
    "deleted": "Format deleted.",
    "emptyTitle": "No formats yet",
    "emptyBody": "Bring your formats over from the old EDD Builder, start from a standard format, or build a blank one.",
    "emptyImport": "Import from the old app",
    "emptyBrowseLibrary": "Start from a standard format",
    "createBlank": "Create a blank format",
    "newModalTitle": "New format",
    "nameLabel": "Name",
    "newModalHint": "Creates a blank CSV format. You can change everything in the format editor, or start from a standard format in the format library.",
    "cloneModalTitle": "Clone format",
    "cloneNameLabel": "New format name",
    "deleteModalTitle": "Delete format",
    "deletePrompt": "Delete <0>{{name}}</0>? This cannot be undone.",
    "copySuffix": "(copy)",
    "defaultName": "New EDD",
    "validTemplate": "Valid template",
    "validTemplateTitle": "All test cases passed against the current version of this EDD.",
    "renamedNotice": "An EDD named \"{{requested}}\" already exists — this one was created as \"{{created}}\"."
  },
  "generate": {
    "title": "Create a deliverable (advanced)",
    "subtitle": "Run a saved format against your data and download the deliverable in any output. For the guided version, use Create a deliverable.",
    "jobHistory": "History",
    "step1": "1. Format & data",
    "config": "Format",
    "selectConfig": "Select a format…",
    "loadingConfigs": "Loading your formats…",
    "noConfigsHint": "You have no formats yet — add one from the format library.",
    "browseTemplates": "Browse the format library",
    "source": "Your data",
    "sourceHint": "Sample data is preview only — not for submission.",
    "synthetic": "Sample data (preview only)",
    "sampleRows": "Sample rows",
    "uploadTitle": "Drag your work-order export here",
    "uploadSublabel": "or click to browse for your Element/Promium export.",
    "uploadHint": ".mdb (output.mdb) or a zip of the Out*.csv files.",
    "uploading": "Uploading…",
    "step2": "2. Output",
    "delimiterSeparator": "Delimiter separator",
    "separatorHint": "Applies to delimited (CSV) output.",
    "runTransforms": "Run the format's calculations & rules",
    "step3": "3. Check before you send",
    "aboutValidation": "About checking before you send",
    "aboutValidationBody": "Checks the generated rows against a regulator standard — required fields, valid-value membership, data types, and date/number/column-name formats — and reports any problems in plain English. Leave the standard on auto-detect to match by the format's family.",
    "validateOutput": "Check the output against a regulator standard",
    "regulatorSpec": "Regulator standard",
    "loadingSpecs": "Loading standards…",
    "autoDetectHint": "Leave on auto-detect to match by family.",
    "autoDetect": "Auto-detect from the format",
    "runName": "Deliverable name (optional)",
    "runNamePlaceholder": "Defaults to the format name",
    "runGeneration": "Create deliverable",
    "runningEngine": "Building your deliverable…",
    "openFullDetail": "Open full detail",
    "downloadZip": "Download .zip",
    "downloadThisItem": "Download this item",
    "pickConfig": "Pick a format to use.",
    "pickFormat": "Choose at least one output.",
    "uploaded": "Uploaded {{name}}.",
    "complete": "Deliverable ready.",
    "failed": "Couldn't build the deliverable.",
    "rowSummary": "{{sx}} sample results · {{qa}} QC results",
    "formats": {
      "delimited": "Delimited (CSV/TSV/PSV)",
      "excel": "Excel (.xlsx)",
      "xml": "XML",
      "access2": "Access 2000 (.mdb)",
      "access7": "Access 2007 (.accdb)"
    },
    "separators": {
      "comma": "Comma (,)",
      "tab": "Tab",
      "pipe": "Pipe (|)"
    },
    "readiness": {
      "loaded": "Cross-tables loaded ✓ ({{count}} tables)",
      "partial": "Partial — missing: {{missing}}",
      "none": "No cross-tables uploaded",
      "fallback": "Using shipped defaults (no org upload)",
      "manageLink": "Manage cross-tables on Profile"
    }
  },
  "jobs": {
    "title": "History",
    "subtitle": "Every deliverable you've created, newest first.",
    "newRun": "Create a deliverable",
    "newBatch": "Multiple work orders",
    "colName": "Name",
    "colKind": "Kind",
    "colStatus": "Status",
    "colConfig": "Format",
    "colItems": "Items",
    "colFormats": "Output",
    "colCreated": "Created",
    "unnamed": "(unnamed)",
    "itemsFailed": "({{count}} failed)",
    "deleted": "Deliverable deleted.",
    "emptyTitle": "No deliverables yet",
    "emptyBody": "Create a deliverable from one of your formats to see it here.",
    "emptyCreateFirst": "Create your first deliverable",
    "deleteModalTitle": "Delete deliverable",
    "deletePrompt": "Delete <0>{{name}}</0> and its result bundle? This cannot be undone.",
    "thisJob": "this deliverable",
    "backToHistory": "← History",
    "downloadAll": "Download all (.zip)",
    "downloadItem": "Download item",
    "unnamedJob": "(unnamed deliverable)",
    "detailConfig": "Format",
    "detailSource": "Data",
    "detailFormats": "Output",
    "detailItems": "Items",
    "detailCreated": "Created",
    "detailUpdated": "Updated",
    "itemsOk": "{{done}}/{{total}} ok",
    "itemsFailedSuffix": " · {{count}} failed",
    "sampleQcRows": "{{sx}} sample results · {{qa}} QC results"
  },
  "gettingStarted": {
    "title": "Getting started",
    "whatIsEdd": "What is an EDD?",
    "whatIsEddBody": "An EDD (Electronic Data Deliverable) is a formatted export of lab results — CSV, Excel, Access, or XML — that a lab sends to a client or regulator. Prisma EDD Builder lets you build, run, and validate these formats without writing code.",
    "subtitle": "From upload to deliverable in seven steps. Each step links to the screen that does it.",
    "step1Title": "Pick or clone a template",
    "step1Body": "Browse the catalog of 196 EDD formats — 35 configurable templates plus 161 Standard Library formats. Open one to inspect its fields, transforms, and cross-tables, then clone it into your own editable config.",
    "step1Cta": "Browse templates",
    "step2Title": "Upload your data (optional)",
    "step2Body": "Generation defaults to deterministic synthetic Out* rows, so you can preview without any upload. To produce a real deliverable, upload an Element output.mdb (one per Work Order) or a zip of Out*.csv files on the Generate screen.",
    "step2Cta": "Go to Generate",
    "step3Title": "Map fields & set the output format",
    "step3Body": "In the config editor, map each output column (Heading) to an Element source field and choose the output format (delimited, Excel, Access, or XML). Headings must contain no spaces — they become CSV headers, Access field names, XML tags, and the identifiers your transforms reference.",
    "step3Cta": "Open My Configs",
    "step4Title": "Cross-table match & add transforms",
    "step4Body": "Turn on cross-tables to translate Element values (analyte, matrix, units…) into the regulator's valid-value codes. Add ordered Jet UPDATE transforms for calculations the grid can't do (e.g. flag results below the MDL). Hidden helper columns stay available to transforms but are dropped from the file.",
    "step4Cta": "Edit a config",
    "step5Title": "Preview & generate",
    "step5Body": "Run the config against your chosen source to build the SXDATA (samples) and QADATA (QC) tables, then render the deliverable. Inspect a sample inline, then download the bundled .zip.",
    "step5Cta": "Generate an EDD",
    "step6Title": "Validate against a regulator spec",
    "step6Body": "Before submitting, validate the output against a regulator spec — required fields, valid values, types, and date/number formats — with plain-English messages (no Jet error codes). You can also drift-check a config against a spec in the registry.",
    "step6Cta": "Open spec registry",
    "step7Title": "Download or write back",
    "step7Body": "Download the generated files, or — for QueryDef-backed EDDs the cloud engine can't write — enqueue a write-back to a Windows worker running on your Promium machine, which writes native Jet QueryDefs and hands the file back.",
    "step7Cta": "Windows worker",
    "rulesTitle": "Key rules to remember",
    "rule1Strong": "Headings have no spaces.",
    "rule1Body": "They become column headers, Access field names, XML tags, and SQL identifiers.",
    "rule2Strong": "Transforms are Jet UPDATE statements",
    "rule2Body": "over SXDATA / QADATA, referencing columns by their Heading.",
    "rule3Strong": "Single-file EDDs",
    "rule3Body": "need the SX and QA grids to share the same field count, order, and headings.",
    "rule4Strong": "QueryDef configs are read-only",
    "rule4Body": "here and need the Windows worker to write back."
  },
  "ai": {
    "findByDescription": "Find a template by description",
    "localMode": "local mode",
    "localModeTitle": "Set ANTHROPIC_API_KEY for smarter results",
    "notConfigured": "AI not configured",
    "describePlaceholder": "Describe what you need — e.g. 'ESdat soil and water EDD for NSW EPA'",
    "useThis": "Use this",
    "hasConfig": "has config",
    "notConfiguredBanner": "AI is not configured — set ANTHROPIC_API_KEY for smarter results. Deterministic search still works.",
    "interpretedAs": "Interpreted as:",
    "noStrongMatches": "No strong matches found. Try a different description or browse all 196 templates below.",
    "createdFromTemplate": "Config \"{{name}}\" created from template.",
    "draftTitle": "Build EDD from description",
    "draftSubtitle": "Describe the EDD you need in plain English. The AI will propose a complete config that you review and approve.",
    "draftNotConfigured": "AI not configured — set ANTHROPIC_API_KEY for smarter results. Deterministic pattern matching will still produce a useful draft.",
    "draftLocalMode": "Running in local mode — set ANTHROPIC_API_KEY for smarter, description-aware drafts.",
    "describeYourEdd": "Describe your EDD",
    "draftDescPlaceholder": "e.g. An ESdat-compatible EDD for soil and water results in CSV format with analyte cross-table mapping and a non-detect qualifier transform.",
    "startFromTemplate": "Start from template (optional — paste template ID or name)",
    "startFromTemplatePlaceholder": "e.g. esdat_csv or leave blank",
    "buildDraft": "Build draft",
    "proposal": "Proposal",
    "buildSteps": "Build steps",
    "validationIssues": "Validation issues ({{count}})",
    "feedbackHistory": "Feedback history",
    "refineProposal": "Refine the proposal",
    "refinePlaceholder": "e.g. add a qualifier transform, use pipe separator instead",
    "refine": "Refine",
    "createThisConfig": "Create this config",
    "configCreated": "Config \"{{name}}\" created.",
    "notConfiguredFuzzy": "AI not configured — set ANTHROPIC_API_KEY for smarter results. Fuzzy/CAS matching still works.",
    "notConfiguredMapping": "AI not configured — set ANTHROPIC_API_KEY for smarter results. Deterministic mapping still works.",
    "notConfiguredPattern": "AI not configured — set ANTHROPIC_API_KEY for smarter results. Pattern-based suggestions still work.",
    "crossTitle": "AI Cross-Table Matching",
    "xtableLabel": "X-table",
    "elementValuesLabel": "Element values to match (comma or newline separated)",
    "elementValuesPlaceholder": "e.g. Benzene, Toluene, Ethylbenzene",
    "matchValuesIn": "Match {{values}} in {{xtable}}",
    "matchValuesGeneric": "values",
    "matchValueCount_one": "{{count}} value",
    "matchValueCount_other": "{{count}} values",
    "kind": "Kind:",
    "noMatchFound": "No match found for:",
    "matchCount_one": "{{count}} match",
    "matchCount_other": "{{count}} matches",
    "approveAll": "Approve all",
    "applyApproved": "Apply approved ({{count}})",
    "colElementValue": "Element value",
    "colMatchedCode": "Matched code",
    "colLabel": "Label",
    "colConfidence": "Confidence",
    "colMethod": "Method",
    "matchesApproved_one": "{{count}} match approved.",
    "matchesApproved_other": "{{count}} matches approved.",
    "mappingTitle": "AI Field Mapping",
    "proposeMapping": "Propose mapping",
    "validationIssuesInProposal": "Validation issues in proposal:",
    "unmappedHeadings": "Unmapped headings (no source found):",
    "perFieldConfidence": "Per-field confidence",
    "colGrid": "Grid",
    "colHeading": "Heading",
    "colMapsTo": "Maps to",
    "colReason": "Reason",
    "mappingRefinePlaceholder": "Refine: e.g. 'swap LabID and SampleName'",
    "approveMapping": "Approve mapping",
    "discard": "Discard",
    "mappingApplied": "AI mapping applied.",
    "recordingTitle": "Recording…",
    "listening": "Listening…",
    "confidenceTitle": "Confidence: {{pct}}%",
    "transformTitle": "AI Transform Assistant",
    "describeTransform": "Describe a transform in plain English",
    "transformInstructionPlaceholder": "e.g. if result below MDL, set Qualifier to U and prefix Result with <",
    "generateSql": "Generate SQL",
    "generatedSql": "Generated SQL",
    "attempt": "(attempt {{n}})",
    "dryRunFailed": "Dry-run failed.",
    "before": "Before",
    "after": "After",
    "approveAndAdd": "Approve & add",
    "couldNotGenerate": "Could not generate a valid transform.",
    "transformGenerationFailed": "Transform generation failed.",
    "transformAdded": "Transform added.",
    "suggestedTransforms": "Suggested transforms for this config",
    "add": "+ Add",
    "suggestionAdded": "\"{{title}}\" added.",
    "noChanges": "No changes — the proposal matches the current config.",
    "fieldChanges": "Field changes ({{n}})",
    "transformChanges": "Transform changes ({{n}})",
    "crosstableChanges": "Cross-table changes ({{n}})",
    "settingsChanges": "Settings changes ({{n}})",
    "diffColOp": "Op",
    "diffColGrid": "Grid",
    "diffColHeading": "Heading",
    "diffColDetail": "Detail",
    "diffColName": "Name",
    "diffColXtable": "X-table",
    "diffColField": "Field",
    "diffColKey": "Key",
    "diffColBefore": "Before",
    "diffColAfter": "After",
    "sqlModified": "SQL modified"
  },
  "mic": {
    "start": "Start voice input",
    "stop": "Finish recording",
    "micLabel": "🎙 Mic",
    "stopLabel": "⏹ Finish recording",
    "live": " (live)",
    "noAudio": "I didn't catch any audio — check your microphone and try again.",
    "noSpeech": "I couldn't make out any speech. Try again and speak a little louder.",
    "processing": "Transcribing…"
  },
  "builder": {
    "chatLabel": "EDD builder chat",
    "emptyState": "Tell me about the file you need, or drop an example, a spec, or any reference docs. I'll ask a few questions, then build a draft you can review.",
    "thinking": "The assistant is thinking…",
    "readyTitle": "Your draft is ready.",
    "readyBody": "I've filled in the fields. Open it in the editor to review and finish.",
    "openInEditor": "Open in the editor"
  },
  "guided": {
    "confidenceLabel": "How sure I am",
    "clarifyTitle": "A couple of things to check first",
    "clarifyHint": "I'm not fully sure here — please read these before you confirm.",
    "looksRight": "Looks right",
    "proposed": "I suggest",
    "changeIt": "Change it",
    "editLabel": "Type the answer you want",
    "columnsTitle": "Proposed columns",
    "editColumns": "Edit the columns",
    "editColumnsLabel": "One column name per line",
    "editColumnsHint": "List the columns you want, one per line, in order.",
    "colName": "Column",
    "customLabel": "Or type your own answer",
    "customPlaceholder": "Type your answer…",
    "confirm": "Confirm",
    "useColumns": "Use these columns",
    "flowToggleLabel": "How should we build?",
    "flowQuick": "Quick",
    "flowStep": "Step-by-step",
    "foundTitle": "What I found and what I still need",
    "foundIntro": "From your files, I spotted these:",
    "surrogates": "Surrogate",
    "internalStandards": "Internal standard",
    "qcTypes": "QC type",
    "missingIntro": "To finish, I still need:",
    "missingHint": "Add these on the files panel and I'll pick them up.",
    "openInEditor": "Open in the editor",
    "barHintQuick": "Confirm each card above. When everything looks right, I'll have your EDD ready.",
    "barHintStep": "Answer the question above and I'll move to the next one.",
    "quickEmpty": "Nothing to review right now — tell me more and I'll add the next questions.",
    "quickHeading": "Review each of these and confirm. You can change any of them.",
    "doneTitle": "All set — your EDD is ready",
    "doneBody": "I've filled everything in. Open it in the editor to preview with your data and finish.",
    "waitingTitle": "Working on it",
    "waitingBody": "Tell me a bit more on the right and I'll get the next question ready.",
    "entryTitle": "Guided builder",
    "entryBody": "I walk you through it one easy step at a time, in plain words, and fill everything in for you to check. Best if you're not sure where to start.",
    "classicTitle": "Classic AI chat",
    "classicBody": "Chat with the AI in an open conversation — type or talk freely and it builds as you go.",
    "chooserTitle": "How should we build?",
    "chooserSubtitle": "Pick whichever feels easier — you can switch any time.",
    "chooserQuick": "Quick review",
    "chooserQuickBody": "I show all my questions at once so you can confirm them fast.",
    "chooserStep": "One step at a time",
    "chooserStepBody": "I ask one simple question at a time and wait for each answer.",
    "thinkingTitle": "The assistant is thinking…",
    "thinkingBody": "I'm working on this — the next step will appear here in a moment.",
    "needsInput": "Needs your input",
    "requirements": {
      "title": "What you've decided so far",
      "hint": "Every choice that's gone into this EDD, and where it came from. Change any of them and I'll redo the rest.",
      "listLabel": "Decisions made so far",
      "edit": "Edit",
      "editAria": "Change \"{{label}}\"",
      "sourceTitle": "Where this came from",
      "source": {
        "user": "You chose",
        "ai_inferred": "I suggested",
        "from_spec": "From your spec",
        "from_cloned_config": "From an existing format",
        "ai": "I suggested",
        "example": "From your example file",
        "output": "From your example file",
        "spec": "From your spec",
        "clone": "From an existing format",
        "unknown": "Decided"
      }
    },
    "validate": {
      "title": "Check before you finish",
      "intro": "I'll look for anything a regulator would reject — unmapped codes, missing required values, bad formats — before you hand this off.",
      "check": "Run the check",
      "recheck": "Run it again",
      "running": "Checking your EDD…",
      "issuesLabel": "Problems found",
      "okBadge": "All clear",
      "ok": "Looks good — no problems found.",
      "severityError": "Must fix",
      "severityWarning": "Heads up",
      "knownGoodTitle": "Prove it matches my known-good file",
      "knownGoodHint": "Drop a work order and the file your regulator already accepted, and I'll confirm this EDD reproduces it exactly.",
      "inputLabel": "Your work order data",
      "inputHint": "The Element export to run (CSV/zip or Access).",
      "expectedLabel": "Your known-good file",
      "expectedHint": "The deliverable the regulator already accepted.",
      "matchBadge": "It matches",
      "matches": "This EDD reproduces your known-good file exactly.",
      "noMatchBadge": "Not yet",
      "noMatch": "It doesn't match your known-good file yet — here's the first difference:",
      "fileMatch": "Matches",
      "fileDiff": "Differs"
    },
    "resume": {
      "title": "Resume your last build",
      "body": "You have an EDD in progress: {{name}}.",
      "untitled": "an unnamed build",
      "action": "Resume",
      "gone": "That build isn't available anymore — starting fresh."
    },
    "clone": {
      "title": "Start from an existing format",
      "hint": "Copy one of your saved EDDs as a starting point and just change what's different.",
      "listLabel": "Your saved formats",
      "start": "Start from this"
    }
  },
  "validation": {
    "title": "Regulator-spec validation",
    "passes": "✓ Passes",
    "noIssues": "✓ No issues",
    "errors_one": "{{count}} error",
    "errors_other": "{{count}} errors",
    "warnings_one": "{{count}} warning",
    "warnings_other": "{{count}} warnings",
    "showDetails": "Show details",
    "hideDetails": "Hide details",
    "noSpecMatched": "No regulator spec was matched. Pick a spec to run format validation.",
    "checkedSummary_one": "Checked {{rows}} row across {{fields}} fields.",
    "checkedSummary_other": "Checked {{rows}} rows across {{fields}} fields.",
    "row": "row {{row}}",
    "value": "value “{{value}}”",
    "codes": {
      "missing_required": "Required field \"{{field}}\" is missing from the output.",
      "bad_value": "Value “{{value}}” for \"{{field}}\" is not an allowed value.",
      "bad_type": "Value “{{value}}” for \"{{field}}\" has the wrong data type.",
      "bad_date": "Value “{{value}}” for \"{{field}}\" is not a valid date.",
      "bad_number": "Value “{{value}}” for \"{{field}}\" is not a valid number.",
      "bad_pattern": "Value “{{value}}” for \"{{field}}\" does not match the required format.",
      "heading_space": "Heading \"{{field}}\" contains spaces — headings must have none.",
      "heading_dup": "Heading \"{{field}}\" is duplicated — headings must be unique.",
      "empty_heading": "A field is missing its heading.",
      "extra_field": "Field \"{{field}}\" is not part of this regulator spec.",
      "querydef_readonly": "This EDD is a Jet QueryDef and is read-only here — clone it to edit.",
      "single_file_parity": "Single-file EDDs require the SX and QA grids to have the same field count, order, and headings.",
      "bad_format": "Unsupported output format.",
      "bad_separator": "Unsupported delimiter separator.",
      "bad_xtable": "Unknown cross-table.",
      "crosstable_empty": "Cross-tables are enabled but no cross-table mappings are defined.",
      "xmap_unknown_heading": "A cross-table mapping refers to a heading that does not exist.",
      "crosstable_unmatched": "A valid EDD cannot be created until ALL items are matched.",
      "crosstable_unmatched_table": "EDD cancelled due to unmatched items in the {{field}} cross table.",
      "bad_source": "Invalid generation source.",
      "bad_csv_zip": "The uploaded zip does not contain valid Out*.csv files.",
      "no_out_csvs": "No Out*.csv files were found in the upload.",
      "output_mdb_unreadable": "The output.mdb could not be read.",
      "schema": "The configuration does not match the expected schema.",
      "no_spec": "No regulator spec was matched.",
      "drift_missing_field": "Required spec field \"{{field}}\" is not emitted by this config.",
      "drift_extra_field": "Emitted heading \"{{field}}\" is not in the current spec.",
      "drift_renamed": "Heading \"{{field}}\" looks like a renamed spec field.",
      "drift_type_mismatch": "Field \"{{field}}\" has a type that disagrees with the spec.",
      "drift_out_of_sync": "This config has drifted from the current regulator spec."
    }
  },
  "admin": {
    "adminsOnlyTitle": "Admins only",
    "adminsOnlyBody": "The admin dashboard — user management, usage analytics, system health, and format coverage — is restricted to admins. Ask an admin to grant you the admin role if you need access.",
    "title": "Admin dashboard",
    "subtitle": "Org users, usage analytics, system health, and the format-coverage rollup.",
    "usersTitle": "Users",
    "analyticsTitle": "Analytics",
    "healthTitle": "System health",
    "coverageTitle": "Format coverage",
    "roleChanged": "{{email}} is now {{role}}.",
    "userRemoved": "User removed.",
    "colEmail": "Email",
    "you": "you",
    "youTitle": "This is you",
    "colRole": "Role",
    "makeRole": "Make {{role}}",
    "cantChangeOwnRole": "You can't change your own role.",
    "colConfigs": "Configs",
    "colGenerations": "Generations",
    "delete": "Delete",
    "noUsersTitle": "No users",
    "noUsersBody": "Your org has no other users yet.",
    "deleteUserTitle": "Delete user",
    "cancel": "Cancel",
    "deleteUserPrompt": "Delete <0>{{email}}</0>? Their configs and history stay in the org but they lose access immediately.",
    "statUsers": "Users",
    "statConfigs": "Configs",
    "statMdbUploads": ".mdb uploads",
    "statGenerations": "Generations",
    "statQuerydefTasks": "QueryDef tasks",
    "successRate": "Success rate",
    "generationsByFormat": "Generations by format",
    "topTemplates": "Top templates",
    "noTemplateUsage": "No template usage yet.",
    "generationsLast30": "Generations (last 30 days)",
    "aiUsage": "AI usage",
    "aiCalls": "{{n}} calls",
    "aiTokens": "{{n}} tokens",
    "noAiCalls": "No AI calls recorded.",
    "noGenerationsYet": "No generations yet.",
    "noGenerationsLast30": "No generations in the last 30 days.",
    "sparklineSummary": "{{total}} total · peak {{peak}}/day",
    "healthDatabase": "Database",
    "healthStorage": "Storage",
    "healthSidecar": "Sidecar",
    "healthAi": "AI ({{provider}})",
    "healthAiError": " · error",
    "healthWorkers": "Workers",
    "workersOnline": "{{n}} online",
    "version": "Version {{version}}",
    "formatsCataloged": "formats cataloged",
    "byTestStatus": "By test status",
    "byRecoverability": "By recoverability",
    "byFamily": "By family",
    "unset": "(unset)"
  },
  "editor": {
    "subtitle": "Format editor",
    "returnToWizardHint": "Done building this format? Head back to your EDD and we'll select it for you.",
    "returnToWizard": "Back to generating my EDD",
    "publish": {
      "draftHint": "This is a draft — only you can see it. Go to the Preview tab, upload one of your data files, and make sure the output looks right. Then publish it for your whole lab.",
      "button": "Publish to my lab",
      "modalTitle": "Publish this format?",
      "modalBody": "Once you publish, everyone in your lab can use this format. Please confirm:",
      "confirm1": "I uploaded a data file and checked the preview output.",
      "confirm2": "I'm confident the result is correct.",
      "published": "Published — your lab can now use this format."
    },
    "chat": {
      "panelTitle": "Assistant",
      "empty": "Ask the assistant anything about this format — define columns, write calculations, or translate values. Attach a reference file if you have one.",
      "collapse": "Hide",
      "reopen": "Assistant"
    },
    "guardrail": {
      "title": "Change a requirement from your file?",
      "body": "Your requirement file asked for {{value}} on {{label}}. Change it anyway?",
      "cancel": "Keep it",
      "changeAnyway": "Change anyway"
    },
    "unsaved": "unsaved",
    "readOnlyBadge": "querydef · read-only",
    "version": "v{{version}}",
    "backToFormats": "← Formats",
    "revert": "Revert",
    "validate": "Check",
    "save": "Save",
    "whyReadOnly": "Why read-only?",
    "whyReadOnlyBody": "This EDD is stored as a native Jet QueryDef, which the cloud engine can't rewrite. Clone it to make an editable copy here, or use the Windows connector to write the QueryDef back on your Promium machine.",
    "readOnlyBanner": "This EDD is stored as a Jet QueryDef and cannot be edited in place. Clone it to make an editable copy.",
    "cloneToEdit": "Clone to edit",
    "cloneModalTitle": "Clone to edit",
    "cloneNameLabel": "New format name",
    "createEditableCopy": "Create editable copy",
    "editableSuffix": "(editable)",
    "editableCopyCreated": "Editable copy created.",
    "fixBeforeSave": "Fix the validation errors before saving.",
    "savedWithErrors": "Saved with errors — see the strip below.",
    "savedVersion": "Saved as v{{version}}.",
    "backendPassed": "Check passed.",
    "backendIssues": "Check found issues.",
    "techNoticeTitle": "This format is managed by your QC team",
    "techNoticeBody": "Formats are set up by your lab admin / QC manager. You can preview this format and use it in Create a deliverable.",
    "tabs": {
      "settings": "Settings",
      "mapping": "Columns",
      "crosstable": "Value translations",
      "transforms": "Calculations & rules",
      "engine": "Recovered logic",
      "preview": "Preview",
      "tests": "Tests"
    },
    "tabHelp": {
      "crosstable": "Map our lab's codes to the regulator's codes (analyte, matrix, units, and more).",
      "transforms": "Auto-fill and qualifier rules that run before the file is created.",
      "engine": "The read-only Jet-SQL transform logic recovered from your lab's original Promium program (eddcustom.dll) that turns your lab data into this deliverable. Only shown when this format actually has recovered logic.",
      "tests": "Attach up to five test cases: an input file from Promium plus the known-good output files from your previous software. Running a test generates this EDD and compares every file — all tests passing marks this format a valid template."
    },
    "engine": {
      "provExtracted": "Recovered from your eddcustom.dll",
      "provVerified": "Verified — matches the original exactly",
      "provBuiltin": "Built-in standard-library engine",
      "none": "There's no extra engine logic for this format — it's a straightforward column writer."
    },
    "settings": {
      "general": "General",
      "eddName": "Format name",
      "outputFormat": "Output format",
      "separator": "Separator",
      "separatorHint": "Only applies to delimited (CSV) output.",
      "fileExtension": "File extension",
      "crossTableDb": "Value-translation database (.mdb)",
      "crossTableDbHint": "The workbook used for value translations.",
      "quoteLevel": "Text quoting",
      "quoteLevelHelp": "Controls when text values are wrapped in quotation marks in delimited (CSV) output. Leave on Default unless the regulator's spec requires a specific quoting style.",
      "quoteLevel0": "Default",
      "quoteLevel1": "Quote all values",
      "quoteLevel2": "Quote text values only",
      "quoteLevel3": "No quotes",
      "queryDefName": "Saved-query name",
      "queryDefNameHelp": "This format runs a saved Access query. Enter the name of that saved query exactly as it is stored in the database. If left blank, the format name is used.",
      "queryDefNameHint": "Leave blank to use the format name.",
      "fileNames": "File names",
      "sxFileName": "Sample-results file/table name",
      "qaFileName": "QC-results file/table name",
      "flags": "Options",
      "includeHeaders": "Include column-names row",
      "separateFiles": "Separate sample / QC files (two files)",
      "useCrosstable": "Use value translations",
      "addWo": "Use Work Order in file name",
      "addDatestamp": "Add date/time stamp to file name",
      "xTableExists": "Value-translation workbook exists",
      "xTableExistsHelp": "Indicates the value-translation workbook (.mdb) for this format already exists on disk. Turn this on if the workbook has already been created; leave it off and the workbook will be created the first time the format runs.",
      "singleFileInfo": "Single-file with QC: the sample-results and QC-results columns must have identical count, order, and column names. Pad sample-only columns with Static-Value dummies."
    },
    "mapping": {
      "sxGrid": "Sample results",
      "qaGrid": "QC results",
      "headingRules": "Column-name rules",
      "headingRulesBody": "Column names may contain spaces and most characters — they become the CSV header / Access field / XML tag. The one caveat: if a calculation or rule references a column, bracket it (e.g. [Result Value]).",
      "fieldTips": "Field-mapping tips",
      "fieldTipsBody": "Some formats expect specific source fields: the Sample Fraction lives in AnalysisInfo1, and the PickList value this format needs is read from AnalysisInfo4. Please verify the sys_loc_code from the COC and edit if necessary. If a record is missing its Total/Dissolved (T or D) value, either exit and enter T or D manually, or remove records with missing TorD data before generating.",
      "addStaticDummy": "+ Static dummy",
      "addField": "+ Add column",
      "parityMismatch": "Single-file with QC: sample results have {{sx}} columns, QC results have {{qa}}. They must match in count, order, and column names.",
      "parityOk": "Single-file with QC: sample-results and QC-results columns must share identical column names in the same order.",
      "emptyTitle": "No columns in {{grid}}",
      "emptyReadOnly": "This grid is empty.",
      "emptyEditable": "Add a column, then drag a source from the left onto it to map it.",
      "addFirst": "+ Add the first column"
    },
    "fieldRow": {
      "dragToReorder": "Drag to reorder",
      "headingPlaceholder": "Heading (no spaces)",
      "mappedSource": "Mapped source",
      "staticPrefix": "= {{value}}",
      "dropSource": "drop a source field →",
      "hidden": "hidden",
      "removeField": "Remove field",
      "type": "Type",
      "size": "Size",
      "dateFormat": "Date format",
      "dateFormatPlaceholder": "mm/dd/yyyy",
      "numberFormat": "Number format",
      "numberFormatPlaceholder": "0.000",
      "bitFormat": "Bit format (true:false)",
      "bitFormatPlaceholder": "Y:N",
      "staticValue": "Static value",
      "staticValuePlaceholder": "literal or token",
      "splitDelimiter": "Split delimiter",
      "splitDelimiterPlaceholder": "::",
      "item": "Item (1-based)",
      "hideFromOutput": "Hide from output"
    },
    "source": {
      "dragHint": "Drag onto a heading to map {{table}}.{{field}}",
      "filterPlaceholder": "Filter source fields…",
      "noMatch": "No source fields match."
    },
    "crosstable": {
      "intro": "Value translations map Element values to client/regulator valid-value codes. <0>Unmatched values come out blank — they never error.</0>",
      "disabled": "Value translations are currently turned off in Settings. These translations are saved but won't apply until you turn on \"Use value translations\".",
      "sxMaps": "Sample translations",
      "qaMaps": "QC translations",
      "addMapping": "+ Add translation",
      "emptyTitle": "No value translations",
      "emptyBody": "Map a column to a translation table to replace its values with the regulator's valid-value codes.",
      "colTable": "Translation table",
      "colColumn": "Column to translate",
      "colSource": "Source table",
      "matchAllLabel": "About strict matching",
      "matchAllHelp": "Some formats require strict matching: a valid EDD cannot be created until ALL items are matched. If any item is unmatched, the run is cancelled (for example: \"EDD cancelled due to unmatched items in the Analyte cross table\"). Match every value before generating."
    },
    "crossTableValues": {
      "heading": "This template's own cross-table values",
      "intro": "Give this template its own valid-value tables, uploaded as an X*.mdb workbook or a single X*.csv. For any table you upload here, these values replace your lab's shared (org) values for THIS template only; every other table still uses the shared values.",
      "uploadLabel": "Upload a cross-table for this template",
      "uploadSublabel": "X*.mdb workbook or a single X*.csv (e.g. XAnalyte.csv)",
      "uploadHint": "The file name (or each table name inside the .mdb) is the cross-table it updates — e.g. XAnalyte, XMatrix.",
      "uploading": "Uploading…",
      "uploaded": "Cross-table saved ({{rows}} rows).",
      "uploadError": "Could not upload cross-table: {{detail}}",
      "colTable": "Table",
      "colRows": "Rows",
      "colSource": "Source file",
      "colUpdated": "Updated",
      "empty": "No per-template cross-tables yet. This template uses your lab's shared cross-tables until you upload one here.",
      "confirmDeleteTitle": "Remove cross-table override",
      "confirmDelete": "Remove this template's own \"{{name}}\" values? Generation will fall back to your lab's shared values for that table.",
      "deleteSuccess": "Removed the \"{{name}}\" override.",
      "deleteError": "Could not remove cross-table: {{detail}}",
      "saveAsBook": "Save as reusable cross-table",
      "saveAsTitle": "Save as a reusable cross-table",
      "saveAsIntro": "Create a named cross-table from this template's values so you can reuse them on other formats. The new cross-table is attached to this template.",
      "saveAsNameLabel": "Cross-table name",
      "saveAsConfirm": "Save as cross-table",
      "savedAsBook": "Saved “{{name}}” — {{count}} value(s). It's now attached and reusable on any format.",
      "manageShort": "Cross-tables",
      "manageFor": "Cross-tables — {{name}}"
    },
    "transforms": {
      "functionHelp": "Supported functions: IIF, SWITCH, MID, INSTR, VAL, Format, and & for joining text. Calculations & rules run against the sample-results / QC-results tables, referencing columns by their column name.",
      "sxTransforms": "Sample calculations",
      "qaTransforms": "QC calculations",
      "addTransform": "+ Add calculation",
      "emptyTitle": "No calculations & rules",
      "emptyBody": "Calculations & rules are the only way to compute values. Add one to derive columns (e.g. a non-detect qualifier from the result and detection limit).",
      "namePlaceholder": "Calculation name",
      "run": "Run",
      "dryRun": "Test",
      "dryRunTitle": "Test this calculation against sample rows",
      "dryRunDone": "Test completed.",
      "dryRunFailed": "Calculation failed.",
      "before": "Before",
      "after": "After",
      "didNotRun": "The calculation did not run.",
      "loadingEditor": "Loading editor…",
      "sqlPlaceholder": "UPDATE SXDATA SET Qualifier = IIF(VAL(nResult) < VAL(nMDL), 'U', Qualifier)"
    },
    "preview": {
      "source": "Your data",
      "sampleData": "Sample data (preview only)",
      "sampleRows": "Sample rows",
      "runTransforms": "Run calculations & rules",
      "runPreview": "Run preview",
      "singleFile": "single file",
      "twoFiles": "two files",
      "warnings_one": "{{count}} warning",
      "warnings_other": "{{count}} warnings",
      "generatedOutput": "Generated output",
      "resultsBelow": "Result tables shown below.",
      "sxResult": "Sample results",
      "qaResult": "QC results",
      "rows_one": "{{count}} row",
      "rows_other": "{{count}} rows",
      "summary": "Format summary",
      "sumFormat": "Output format",
      "sumExtension": "Extension",
      "sumSx": "Sample columns",
      "sumQa": "QC columns",
      "sumTransforms": "Calculations & rules",
      "sumCrosstable": "Value translations",
      "on": "on",
      "off": "off"
    },
    "tests": {
      "intro": "A test case pairs one input file from Promium with the known-good output files your previous software produced. Run it to generate through this EDD and compare every file byte for byte.",
      "heading": "Test cases",
      "count": "{{n}} of {{max}}",
      "validTemplate": "Valid template",
      "validTemplateHint": "Every test case passed against the current version of this EDD.",
      "runAll": "Run all",
      "run": "Run",
      "dirtyHint": "You have unsaved changes. Tests always run against the SAVED version — save first so the results reflect what you see.",
      "addTest": "Add test",
      "capReached": "This EDD has the maximum of {{max}} tests. Delete one to add another.",
      "nameLabel": "Test name",
      "namePlaceholder": "e.g. Work order 12345 — full run",
      "inputKindLabel": "Input type",
      "kindOutputMdb": "Promium output.mdb",
      "kindCsvZip": "Zip of Out*.csv files",
      "inputFileLabel": "Input file (from Promium)",
      "expectedFilesLabel": "Expected output files (the good files)",
      "expectedFilesHint": "The deliverable files your previous software generated for this same input. Text files compare byte-for-byte; .xlsx compares cell contents.",
      "create": "Create test",
      "formIncomplete": "Give the test a name, an input file, and at least one expected output file.",
      "formIncompleteGenerate": "Give the test a name and an input file to generate the output.",
      "modeLabel": "Expected output",
      "modeUpload": "Upload expected files (known-good)",
      "modeGenerate": "Generate & confirm expected (for new formats)",
      "modeUploadHint": "Attach the deliverable files your previous software produced for this input.",
      "modeGenerateHint": "No known-good file yet? Generate the output from this EDD, preview it, and save it as the expected baseline future runs compare against.",
      "generatePreview": "Generate preview",
      "generating": "Generating…",
      "previewTitle": "Preview generated output",
      "previewBody": "This is the output this EDD produced for your input. Confirm to save these exact files as the test's expected output; future runs compare against them byte for byte.",
      "confirmSave": "Confirm & save",
      "bytes": "{{n}} bytes",
      "created": "Test case added.",
      "emptyTitle": "No tests yet",
      "emptyBody": "Add your first test case: upload an input file from Promium and the known-good output files it should produce.",
      "status": {
        "pending": "Not run",
        "passed": "Passed",
        "failed": "Failed",
        "error": "Error"
      },
      "stale": "Stale",
      "staleHint": "This EDD changed since the test last ran. Re-run it to refresh the result.",
      "expectedCount": "{{n}} expected file(s)",
      "hideDetail": "Hide details",
      "showDetail": "Show details",
      "fileCol": "File",
      "resultCol": "Result",
      "detailCol": "Detail",
      "contentCompare": "content",
      "contentCompareHint": "Excel workbooks are compared by cell contents (raw .xlsx bytes always differ).",
      "match": "Identical",
      "mismatch": "Different"
    }
  },
  "batch": {
    "title": "Multiple work orders",
    "subtitle": "Run one format across many work orders. Get a single zip with one folder per work order.",
    "history": "History",
    "format": "Format",
    "selectFormat": "Select a format…",
    "output": "Output",
    "checkEach": "Check each work order against a regulator standard",
    "autoDetect": "Auto-detect",
    "sources": "Work orders ({{count}})",
    "addSource": "+ Add work order",
    "uploadTitle": "Drag a work-order export here to add it",
    "uploadSublabel": "or click to browse. We'll add it as a new row.",
    "uploadHint": ".mdb (output.mdb) or a zip of the Out*.csv files.",
    "uploading": "Uploading…",
    "sample": "Sample data",
    "name": "Batch name (optional)",
    "namePlaceholder": "Defaults to the format name",
    "run": "Run ({{count}})",
    "running": "Running {{count}} work order(s)…",
    "openFullDetail": "Open full detail",
    "downloadAll": "Download all (.zip)",
    "uploaded": "Uploaded {{name}}.",
    "pickFormat": "Pick a format to use.",
    "addAtLeastOne": "Add at least one work order.",
    "pickOutput": "Choose at least one output.",
    "complete": "All deliverables ready.",
    "partial": "Finished with some failures.",
    "failed": "Run failed.",
    "colWorkOrder": "Work order",
    "colStatus": "Status",
    "colSx": "Sample rows",
    "colQa": "QC rows",
    "colFiles": "Files",
    "colCheck": "Check",
    "itemsOk": "{{done}}/{{total}} ok",
    "itemsFailedSuffix": " · {{count}} failed"
  },
  "merge": {
    "title": "Combine formats",
    "subtitle": "Pick columns from one or more formats into a single new format. Column names must stay unique; single-file parity is padded automatically.",
    "newName": "New format name",
    "defaultName": "Combined EDD",
    "pickSource": "Pick a source",
    "myFormat": "My format",
    "templateOption": "Standard format (by class/name)",
    "sxGrid": "Sample results",
    "qaGrid": "QC results",
    "format": "Format",
    "selectFormat": "Select a format…",
    "templateClass": "Standard format class or name",
    "templateClassPlaceholder": "e.g. clsEQUIS or NYSDEC",
    "templateClassHint": "Use the exact class/name from the format library.",
    "loadingFields": "Loading columns…",
    "colHeading": "Column name",
    "colSource": "Source",
    "add": "+ Add",
    "chooseFormatToList": "Choose a format to list its columns.",
    "enterTemplateToList": "Enter a standard format class/name to list its columns.",
    "noFieldsInGrid": "No columns in this grid.",
    "selectedFields": "Selected columns",
    "dupHeadings": "Duplicate column names (case-insensitive): {{names}}. Remove or rename before combining.",
    "emptyCart": "Add columns from the left to build your combined format.",
    "colGrid": "Grid",
    "colFrom": "From",
    "createMerged": "Create combined format",
    "pickAtLeastOne": "Pick at least one column to combine.",
    "resolveDup": "Resolve duplicate column names before combining.",
    "created": "Combined format created."
  },
  "specs": {
    "title": "Standards",
    "aboutLabel": "About standards",
    "aboutBody": "A standard is the target shape a regulator or client expects: the required columns, their types, valid-value lists, and date/number formats. Check or drift-check your EDD against it before submitting. Built-in (file) standards are read-only; admins can seed them into the database to make editable, versioned copies.",
    "subtitle": "The merged registry — built-in standards plus your org's living standards (your org's wins on conflicts).",
    "seed": "Seed built-in standards → database",
    "newSpec": "+ New standard",
    "seeded": "Seeded {{seeded}} standard(s) into the database ({{skipped}} already present).",
    "searchLabel": "Search",
    "searchPlaceholder": "name, regulator, family…",
    "noSpecs": "No standards",
    "tryAnother": "Try a different search.",
    "selectSpec": "Select a standard",
    "selectSpecBody": "Pick a standard on the left to view its columns, version history, and run a drift check.",
    "fieldsLabel": "fields",
    "org": "org",
    "validValueLists": "valid-value lists",
    "readOnly": "read-only",
    "readOnlyTitle": "Built-in / global standards are read-only. Seed into the database to edit.",
    "regulator": "Regulator",
    "family": "Family",
    "effective": "Effective",
    "fieldCount": "Fields",
    "deleteTitle": "Delete standard",
    "deleted": "Standard deleted.",
    "deletePrompt": "Delete <0>{{name}}</0> and its version history? This cannot be undone. Built-in standards are unaffected.",
    "fields": "Columns",
    "noFieldsTitle": "No columns recorded",
    "noFieldsBody": "This standard has no column list — only its metadata is known.",
    "colField": "Column",
    "colType": "Type",
    "colRequired": "Required",
    "colFormatSize": "Format / size",
    "colValidValues": "Valid values",
    "required": "required",
    "sizeLabel": "size {{size}}",
    "versionHistory": "Version history",
    "noSnapshots": "No snapshots yet.",
    "colVersion": "Version",
    "colLabel": "Label",
    "colFields2": "Fields",
    "colSummary": "Summary",
    "colCreated": "Created",
    "from": "From",
    "to": "To",
    "pickTwo": "Pick two different versions to compare.",
    "noDiff": "No column differences between these versions.",
    "added": "+{{count}} added",
    "removed": "−{{count}} removed",
    "changed": "{{count}} changed",
    "addedSuffix": "added",
    "removedSuffix": "removed",
    "changedSuffix": "changed",
    "checkDrift": "Check drift",
    "aboutDrift": "About drift",
    "aboutDriftBody": "Drift compares a format's emitted column names and types against this standard's current columns. It flags missing required columns, extra columns, likely renames, and type mismatches — and suggests a fix.",
    "driftIntro": "Run one of your saved formats against <0>{{name}}</0> to see whether its output still matches the standard.",
    "selectFormat": "Select a format…",
    "loadingConfigs": "Loading formats…",
    "pickConfigFirst": "Pick a format and let it load first.",
    "driftReport": "Drift report",
    "inSync": "✓ In sync",
    "outOfSync": "Out of sync",
    "matchesSpec": "The format's output matches the standard.",
    "missingRequired": "Missing required column",
    "typeMismatch": "{{field}} is {{eddType}}, standard expects {{specType}}",
    "renamedSuspect": "looks like a rename of",
    "matchScore": "({{score}}% match)",
    "extraColumn": "Extra column",
    "notInSpec": "(not in the standard)",
    "specKeyRequired": "Standard key and name are required.",
    "fieldNoSpaces": "Column names cannot contain spaces (they become column/XML/SQL identifiers).",
    "updated": "Standard updated — new version snapshotted.",
    "created": "Standard created.",
    "editTitle": "Edit {{name}}",
    "newTitle": "New regulator standard",
    "saveNewVersion": "Save new version",
    "createSpec": "Create standard",
    "specKey": "Standard key",
    "specKeyHint": "Stable id; dedupes against built-in standards. Defaults to the name.",
    "name": "Name",
    "version": "Version",
    "sourceUrl": "Source URL",
    "notes": "Notes",
    "fieldRules": "Column rules",
    "fieldRulesBody": "Column names become column headers / XML tags / SQL identifiers, so they must contain no spaces. Add valid values as a comma-separated list to enforce membership during a check.",
    "addField": "+ Add column",
    "fieldName": "Name",
    "fieldType": "Type",
    "remove": "Remove",
    "validValues": "Valid values (comma-separated, optional)",
    "changeSummary": "Change summary (for the version snapshot)",
    "changeSummaryPlaceholder": "e.g. added matrix valid-value list",
    "confidenceBadge": "{{level}} confidence",
    "aboutConfidence": "About extraction confidence",
    "aboutConfidenceBody": "How much to trust this standard's auto-extracted details (QC limits, analyte lists, formats). High means a clean, structured source; low means the source was harder to parse and the values should be spot-checked against the original document.",
    "extractedFrom": "Extracted from source",
    "extractedAt": "extracted {{date}}",
    "colQc": "QC limits",
    "colAnalytes": "Analytes",
    "analyteVocab": "vocabulary",
    "analyteCasCount": "{{count}} CAS numbers",
    "more": "more"
  },
  "worker": {
    "title": "Windows connector",
    "subtitle": "QueryDef-backed EDDs can't be written by the cloud engine. Run the connector on your Promium / Windows machine and it writes native Jet QueryDefs locally, then hands the file back here.",
    "registerWorker": "+ Register connector",
    "registeredWorkers": "Registered connectors",
    "colName": "Name",
    "colStatus": "Status",
    "colVersion": "Version",
    "colCaps": "Capabilities",
    "colSeen": "Last seen",
    "remove": "Remove",
    "removed": "Connector removed.",
    "noWorkersTitle": "No connectors registered",
    "registerOne": "Register a connector",
    "askAdmin": "Ask an admin to register a connector.",
    "noWorkersBody": "Download the connector, register it here, and it will appear once it checks in.",
    "removeTitle": "Remove connector",
    "removePrompt": "Remove <0>{{name}}</0>? Its token stops working immediately and it can no longer claim tasks.",
    "never": "never",
    "registerTitle": "Register a Windows connector",
    "workerName": "Connector name",
    "defaultWorkerName": "Promium connector",
    "done": "Done",
    "register": "Register",
    "registered": "Connector registered.",
    "copyTokenWarning": "Copy this token now — it is shown only once. Store it on the connector machine.",
    "copied": "Copied!",
    "copy": "Copy",
    "copyFailed": "Could not copy — select and copy the token manually.",
    "tokenInstructions": "On your Windows machine, install the connector from <0>web/agent-worker</0> and run it with this token (sent as the <1>X-Worker-Token</1> header). It will start polling for QueryDef write-back tasks.",
    "registerInstructions": "Registering mints a per-connector token shown once. The connector (in <0>web/agent-worker</0>) uses it to authenticate and poll for tasks. Only admins can register or remove connectors.",
    "enqueueTitle": "Send a QueryDef write-back",
    "enqueueSubtitle": "Pick an uploaded EDDBuilderData.mdb and the QueryDef-backed formats to write. An online connector claims the task, writes the native Jet QueryDefs, and uploads the result.",
    "mdbFile": ".mdb file",
    "selectMdb": "Select a .mdb…",
    "loadingMdb": "Loading your .mdb files…",
    "mdbConfigs": "{{filename}} ({{count}} formats)",
    "noQuerydefConfigs": "This .mdb has no QueryDef-backed formats (or its format summaries aren't loaded). Only QueryDef formats need the connector; others write back from the engine directly.",
    "colConfig": "Format",
    "colFormat": "Output",
    "enqueue": "Send write-back ({{count}})",
    "pickMdb": "Pick a .mdb file.",
    "selectQuerydef": "Select at least one QueryDef format to write back.",
    "taskQueued": "Task queued. Waiting for a connector to claim it…",
    "writebackTask": "Write-back task",
    "worker": "connector {{id}}",
    "waitingClaim": "Waiting for an online connector to claim this task…",
    "writing": "A connector is writing the QueryDefs…",
    "downloadWritten": "Download written .mdb",
    "taskFailed": "The connector could not complete this write-back. Check that it is online and try again."
  },
  "profile": {
    "title": "Profile",
    "account": "Account",
    "email": "Email",
    "displayName": "Display name",
    "organization": "Organization: {{name}}",
    "saveProfile": "Save profile",
    "notifyTitle": "Notifications",
    "notifyNewSignups": "Notify me about new signups",
    "notifyNewSignupsHint": "Get an email and an in-app alert the first time a new user signs in.",
    "saved": "Profile updated.",
    "orgTitle": "Organization",
    "orgName": "Name",
    "orgId": "Org ID",
    "mdbCount": ".mdb files",
    "mdbSectionTitle": "Format databases (.mdb)",
    "uploading": "Uploading and importing formats…",
    "dropTitle": "Drop your EDDBuilderData.mdb here",
    "dropBody": "or click to browse. We import its EDD formats into your workspace.",
    "chooseMdb": "Please choose a .mdb file (EDDBuilderData.mdb).",
    "uploaded": "Uploaded {{name}}.",
    "noMdb": "No .mdb files uploaded yet.",
    "colFile": "File",
    "colSize": "Size",
    "colStatus": "Status",
    "colConfigs": "Formats",
    "download": "Download",
    "writeBack": "Write back…",
    "delete": "Delete",
    "deleteConfirm": "Delete {{name}}?",
    "writebackTitle": "Write formats back to {{filename}}",
    "writebackIntro": "Select which formats to write into a fresh copy of this .mdb. QueryDef-backed formats are skipped automatically (they cannot be written by the engine).",
    "noSummaries": "No imported format summaries available for this file. Re-open the file detail to load them, or write back from the editor once formats are imported.",
    "wbColConfig": "Format",
    "wbColFormat": "Output",
    "wbColQuerydef": "QueryDef",
    "wbReadOnly": "read-only",
    "writeBackAction": "Write back",
    "skipped": "Skipped {{count}} QueryDef format(s) — they are read-only.",
    "wbComplete": "Write-back complete. Your .mdb is ready to download.",
    "wbIssues": "Write-back produced issues.",
    "promiumTitle": "Update Promium files",
    "promiumBody": "Add files you skipped, or re-import after an Element upgrade. We'll bring over any new templates, engines, and cross-table mappings.",
    "promiumStart": "Import Promium files",
    "crossTables": {
      "title": "Cross-tables",
      "body": "Valid-value translation tables uploaded from your X*.mdb files. Used by cross-table formats such as EQuIS.",
      "colName": "Table",
      "colRows": "Rows",
      "colSource": "Source file",
      "colImported": "Imported",
      "delete": "Delete",
      "confirmDelete": "Delete cross-table \"{{name}}\"? This removes all its rows from your org store. You can re-upload the workbook to restore it.",
      "confirmDeleteTitle": "Delete cross-table",
      "cancel": "Cancel",
      "confirm": "Confirm delete",
      "reupload": "Re-upload workbooks",
      "empty": "No cross-tables loaded yet. Upload a cross-table workbook (X*.mdb) using the Update Promium files section.",
      "deleteSuccess": "Cross-table \"{{name}}\" deleted.",
      "deleteError": "Could not delete cross-table: {{detail}}",
      "colElmntValue": "Element value",
      "colMappedValue": "Mapped value",
      "colMappedValue2": "Mapped value 2",
      "valuesOf": "Values — {{name}}",
      "valuesTotalHint": "Showing {{shown}} of {{total}} rows",
      "loadingValues": "Loading values…",
      "noValuesYet": "No values found for this table.",
      "prevPage": "← Prev",
      "nextPage": "Next →"
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread": "{{count}} unread",
    "markAll": "Mark all read",
    "empty": "No notifications yet."
  },
  "sessions": {
    "title": "Devices & sessions",
    "subtitle": "Where you're signed in. Sign out a device if you don't recognize it.",
    "empty": "No active sessions.",
    "thisDevice": "This device",
    "unknownDevice": "Unknown device",
    "lastActive": "Last active {{when}}",
    "signOut": "Sign out",
    "signOutOthers": "Sign out other devices",
    "signedOut": "That device has been signed out.",
    "signedOutOthers": "Signed out of your other devices."
  },
  "templateDetail": {
    "backToLibrary": "← All formats",
    "spec": "Spec ↗",
    "cloneToConfigs": "Add to my formats",
    "about": {
      "title": "About this EDD",
      "forStandard": "This is a Standard EDD Library format for {{subject}}.",
      "forSiteCustom": "This is a Site-Custom EDD made specifically for your lab — {{subject}}.",
      "forCustom": "This is one of your Custom EDDs — {{subject}}.",
      "subjectFallback": "an electronic data deliverable for environmental lab results",
      "fields_one": "**{{count}} field**",
      "fields_other": "**{{count}} fields**",
      "transforms_one": "**{{count}} transform**",
      "transforms_other": "**{{count}} transforms**",
      "crossTables_one": "uses **{{count}} cross-table**",
      "crossTables_other": "uses **{{count}} cross-tables**",
      "noCrossTables": "no cross-tables",
      "statusReady": "✅ Ready to generate",
      "statusNeedsCrosstable": "⚠️ Needs cross-table setup",
      "statusPreviewOnly": "👁️ Preview only — clone it to edit"
    },
    "publicSpec": "public spec",
    "notes": "Notes",
    "provenance": "Provenance",
    "kind": "Kind",
    "recoverability": "Recoverability",
    "hasConfig": "Has format",
    "yes": "Yes",
    "specOnly": "Spec-only",
    "sxFields": "Sample columns",
    "qaFields": "QC columns",
    "output": "Output",
    "format": "Format",
    "separator": "Separator",
    "extension": "Extension",
    "crossTable": "Value translations",
    "twoFile": "Two files",
    "no": "No",
    "singleFile": "Single file",
    "sxFieldsTitle": "Sample columns",
    "qaFieldsTitle": "QC columns",
    "specOnlyBanner": "This format is catalogued as spec-only — its config is not yet ported. You can still add it to start from a blank editable format.",
    "cloneModalTitle": "Add to my formats",
    "cloned": "Added to your formats.",
    "newConfigName": "New format name",
    "createsCopy": "Creates an editable copy in your workspace from <0>{{class}}</0>.",
    "clone": "Add",
    "colNum": "#",
    "colHeading": "Column name",
    "colSource": "Source",
    "colType": "Type",
    "colSize": "Size",
    "colStatic": "Static",
    "colHidden": "Hidden",
    "fieldsCount": "{{count}} columns",
    "yesLower": "yes",
    "transformsTitle": "Transformations (sample)",
    "qaTransformsTitle": "Transformations (QC)",
    "transformsCount": "{{count}} transforms",
    "transformsNote": "Recovered Jet SQL, run in order after the columns are built. `''` marks a runtime value computed from the lab's data.",
    "noTransforms": "No transformations recovered for this format.",
    "colTransformName": "Name",
    "colTransformSql": "Jet SQL (UPDATE)",
    "crossMapsTitle": "Cross-table value maps (sample)",
    "qaCrossMapsTitle": "Cross-table value maps (QC)",
    "crossMapsCount": "{{count}} maps",
    "colXtable": "Valid-value table",
    "colXsource": "Source column",
    "provClass": "VB6 class",
    "provDll": "DLL",
    "provBlock": "Source block",
    "provRecovered": "Recovered fields",
    "sectionsTitle": "Output sections (files)",
    "sectionsNote": "This format writes one file per section, all built from one work table.",
    "sectionsCount": "{{count}} files",
    "colSection": "Section",
    "colSectionFiles": "Output file(s)",
    "colSectionColCount": "# columns",
    "colSectionColumns": "Columns",
    "runtimeOptionsTitle": "Generation-time options",
    "runtimeOptionsNote": "Chosen in the EDD Library dialog when the EDD is run (not fixed in the format). Defaults shown.",
    "runtimeOptionsCount": "{{count}} options",
    "colOption": "Option",
    "colDefault": "Default",
    "dialogControlsTitle": "Options dialog",
    "colXpopulates": "Fills column",
    "engineTitle": "Engine logic (recovered from eddlib.dll)",
    "engineNote": "Recovered verbatim from the compiled app. Shared by every format built on the {{table}} engine — the actual transforms, cross-tables and options that turn lab data into this deliverable.",
    "engineCrossLabel": "Cross-table value translations",
    "engineOptionsLabel": "Engine options",
    "engineShow": "Show all {{count}} transforms",
    "engineHide": "Hide transforms"
  },
  "setup": {
    "title": "Set up your lab",
    "subtitle": "Bring your formats over from the legacy EDD Builder app — no re-typing.",
    "stepLabel1": "Find your file",
    "stepLabel2": "Import",
    "step1Title": "1. Find your EDDBuilderData.mdb",
    "step1Body": "On your Windows machine this is the configuration database the legacy EDD Builder uses — usually in your centralized cross-table directory. It holds every EDD format your lab has built.",
    "step2Title": "2. Upload it here",
    "step2Body": "Drop the file below. We read your formats and import each one as an editable EDD format. Nothing is sent to a regulator — this is just bringing your setup over.",
    "dropTitle": "Drag your EDDBuilderData.mdb here",
    "dropBrowse": "or click to browse",
    "dropHint": "Only .mdb files from the legacy EDD Builder are accepted.",
    "uploading": "Uploading and importing your formats…",
    "chooseMdb": "Please choose a .mdb file (EDDBuilderData.mdb).",
    "uploadFailed": "We couldn't import that file.",
    "successTitle": "Imported {{count}} format(s)",
    "successZeroTitle": "File uploaded",
    "successBody": "Your formats are now in EDD Formats, ready to edit or use in a deliverable.",
    "successZeroBody": "We didn't find any formats in that file. Check that it's the EDDBuilderData.mdb from the legacy EDD Builder.",
    "goToFormats": "Go to EDD Formats",
    "goHome": "Go to dashboard",
    "importAnother": "Import another file",
    "previouslyImported": "You've already imported {{count}} file(s). Upload another to add more formats."
  },
  "promiumImport": {
    "orPickEach": "Or upload each file by hand",
    "orPickEachBody": "If you'd rather not zip the whole folder, find each file below and drop it in. You only truly need the first one.",
    "namePatternLabel": "Name pattern:",
    "whatIsThisLabel": "What is this?",
    "whereLabel": "Where do I find this?",
    "dropSingle": "Drop the file here",
    "dropMulti": "Drop your files here",
    "dropBrowse": "or click to browse",
    "cardDropAria": "Upload {{name}}",
    "removeFile": "Remove",
    "foundInZip": "✓ found in your zip",
    "notAZip": "That doesn't look like a .zip file. Please drop a single zipped folder.",
    "fileTooLarge": "\"{{name}}\" is too large to upload here. It may be the wrong file.",
    "submit": "Set up my lab",
    "gateHint": "Add your EDDBuilderData.mdb to continue (or upload a zip of your C:\\Elmnt folder).",
    "uploadingAria": "Setting up your lab",
    "uploadingPct": "Uploading… {{pct}}%",
    "missingRecommendedTitle": "A few helpful files are missing — that's OK",
    "addLater": "You can add these later from your profile.",
    "badge": {
      "required": "🔵 REQUIRED",
      "recommended": "🟡 RECOMMENDED",
      "optional": "⚪ OPTIONAL"
    },
    "status": {
      "waiting": "Waiting",
      "uploading": "Uploading",
      "done": "Done",
      "error": "Error"
    },
    "zip": {
      "title": "Easiest way: Upload your whole Elmnt folder",
      "body": "Don't want to find each file? Just zip your entire C:\\Elmnt folder and drop it here. We'll find everything automatically.",
      "dropTitle": "Drop your zipped Elmnt folder here",
      "dropAria": "Upload a zip of your C:\\Elmnt folder",
      "staged": "Ready to upload: {{name}}",
      "help": "Right-click the C:\\Elmnt folder → Send to → Compressed (zipped) folder → Upload the zip here."
    },
    "collector": {
      "button": "Download collector script",
      "caption": "Or run our collector on your Windows machine — it finds all the files, zips them, and you upload that one zip."
    },
    "summary": {
      "title": "Your lab is set up! 🎉",
      "body": "Here's everything you can use to make EDDs. You have your own custom EDDs plus a big library of standard formats — all in one place.",
      "whatIsThis": "ℹ️ What is this?",
      "custom": {
        "title": "Your Custom EDDs",
        "count_one": "We found **{{count}} custom EDD**.",
        "count_other": "We found **{{count}} custom EDDs**.",
        "explain": "These are your personal EDD templates. They have your field mappings, your transforms, and your cross-table settings. They're ready to use right away."
      },
      "standard": {
        "title": "Standard EDD Library",
        "count_one": "**{{count}} standard format** is built into Prisma EDD Builder and ready to use.",
        "count_other": "**{{count}} standard formats** are built into Prisma EDD Builder and ready to use.",
        "explain": "These are the standard EDD formats built into Element — EQuIS, SDWIS, state agency formats, military formats, and more. They're built into Prisma EDD Builder; we confirmed your EDD Builder matches this standard library, so they all work exactly like they do in Element."
      },
      "siteCustom": {
        "title": "Site-Custom EDDs",
        "count_one": "We found **{{count}} site-specific format**.",
        "count_other": "We found **{{count}} site-specific formats**.",
        "explain": "These are special formats made specifically for your lab or your state."
      },
      "mappings": {
        "title": "Your Mappings",
        "explain": "These translate your lab's names into the codes that regulators require. For example, your 'Mercury' becomes CAS number '7439-97-6'."
      },
      "errors": {
        "title": "Your Error History",
        "body": "We found some formats that gave you trouble before.",
        "explain": "We found some formats that gave you trouble before. We've pre-configured fixes for these."
      },
      "validValuesIntro": "We imported",
      "vv": {
        "analyte_mappings_one": "**{{count}} analyte mapping**",
        "analyte_mappings_other": "**{{count}} analyte mappings**",
        "matrix_codes_one": "**{{count}} matrix code**",
        "matrix_codes_other": "**{{count}} matrix codes**",
        "unit_codes_one": "**{{count}} unit code**",
        "unit_codes_other": "**{{count}} unit codes**"
      },
      "version": "Detected Element version **{{version}}**",
      "missing": "Missing: {{name}} — you can add this later from your profile.",
      "verifyPassed": "All checks passed",
      "verifyFailedTitle": "Some checks need a second look",
      "seeAllEdds": "See all my EDDs →",
      "continue": "Go to dashboard"
    },
    "cards": {
      "configDb": {
        "fileName": "EDDBuilderData.mdb",
        "aka": "Sometimes called `EDD Builder Data.mdb` or `EDDBuilderData_backup.mdb`",
        "pattern": "Any .mdb file with \"EDDBuilder\" or \"EDD\" and \"Data\" in the name",
        "what": "This file has all your EDD templates — the field mappings, the transforms, everything you've set up in the EDD Builder over the years.",
        "step1": "Open File Explorer on your computer",
        "step2": "Go to `C:\\Elmnt\\` (this is where Promium Element lives)",
        "step3": "Look for a file called `EDDBuilderData.mdb` — it's usually right in that folder",
        "step4": "If it's not there, check `C:\\Elmnt\\CrossTables\\` or `C:\\Program Files\\Promium\\Element\\`",
        "step5": "Still can't find it? Open Element → Database Admin → look at the status bar for the database path"
      },
      "eddlib": {
        "fileName": "eddlib.dll",
        "aka": "The main EDD library",
        "pattern": "`eddlib.dll` — it's always this exact name",
        "what": "This is the brain behind all 161 standard EDD formats — EQuIS, SDWIS, state formats, military formats. Without it, we can only import your custom templates, not the built-in formats.",
        "step1": "Open File Explorer",
        "step2": "Go to `C:\\Elmnt\\`",
        "step3": "Look for `eddlib.dll` — it's about 22 MB, much larger than other DLL files",
        "step4": "If you don't see it, try `C:\\Program Files\\Promium\\Element\\`"
      },
      "eddcustom": {
        "fileName": "eddcustom.dll",
        "aka": "Site-specific or custom DLL",
        "pattern": "`eddcustom.dll` — always this exact name. Not every lab has one.",
        "what": "Some labs have special EDD formats made just for them (like Minnesota MDH formats). This file has those custom engines. If you've never used custom formats, you might not have this file — that's OK, skip it.",
        "step1": "Same folder as eddlib.dll: `C:\\Elmnt\\`",
        "step2": "Look for `eddcustom.dll` — it's smaller than eddlib.dll (usually 1-5 MB)",
        "step3": "Don't have it? That's fine — just skip this one"
      },
      "crosstableDb": {
        "fileName": "XEDDBuilder.mdb",
        "aka": "Cross-table workbook, X-tables, valid-value mappings",
        "pattern": "Any .mdb file starting with `X` — like `XEDDBuilder.mdb`, `XEQuIS.mdb`, `XNYSDEC.mdb`",
        "what": "This file translates your lab's internal names into the codes that regulators accept. For example, it maps your analyte name \"Mercury\" to the CAS number \"7439-97-6\". Without this, you'll need to rebuild these mappings from scratch.",
        "step1": "Go to `C:\\Elmnt\\CrossTables\\`",
        "step2": "Look for `XEDDBuilder.mdb` — this is the main one",
        "step3": "You might also see other X-files like `XEQuIS.mdb` or `XNYSDEC.mdb` — upload those too (Card 7)"
      },
      "outputDb": {
        "fileName": "output.mdb",
        "aka": "Work order export, EDD output data",
        "pattern": "`output.mdb` — always this name, but it's temporary (Element creates a new one each time)",
        "what": "A sample of your actual lab data from one work order. Upload one so we can show you a real preview of your EDDs during setup — you'll see your actual data formatted in your actual templates.",
        "step1": "Open Element → go to any completed work order → Reports → run any EDD",
        "step2": "The `output.mdb` appears in your EDD output folder (usually `C:\\Elmnt\\ServerFolders\\EDD\\`)",
        "step3": "Grab it right after running — Element overwrites it each time"
      },
      "exe": {
        "fileName": "EDDBuilder.exe",
        "aka": "The EDD Builder program",
        "pattern": "`EDDBuilder.exe` — always this exact name",
        "what": "The EDD Builder application itself. We use this to detect which version of Element you're running, so we can make sure everything is 100% compatible.",
        "step1": "Same folder: `C:\\Elmnt\\`",
        "step2": "Look for `EDDBuilder.exe`"
      },
      "extraCrosstables": {
        "fileName": "Various .mdb files",
        "aka": "Per-format cross-tables, regulator mappings",
        "pattern": ".mdb files starting with `X` — like `XEQuIS.mdb`, `XNYSDEC.mdb`, `XCMDP.mdb`, `XSDWIS.mdb`, `XSEDD.mdb`",
        "what": "Some formats have their own separate mapping files. If you have any extra .mdb files in your CrossTables folder, upload them all here.",
        "step1": "Go to `C:\\Elmnt\\CrossTables\\`",
        "step2": "Upload every .mdb file you see (except EDDBuilderData.mdb which goes in Card 1)",
        "note": "This is a multi-file dropzone — drag in as many as you want"
      },
      "log": {
        "fileName": "EDDLIBERR.LOG",
        "aka": "EDD error log",
        "pattern": "`EDDLIBERR.LOG` or `EDDLIBERR_*.LOG` — always has \"EDDLIBERR\" in the name",
        "what": "Your EDD Builder's error log from over the years. We can read this to find which formats gave you trouble and pre-configure fixes so they work right from the start.",
        "step1": "Go to `C:\\Elmnt\\`",
        "step2": "Look for `EDDLIBERR.LOG`",
        "step3": "It might not exist if you've never had EDD errors (lucky you!)"
      }
    }
  },
  "codeBooks": {
    "title": "Cross-tables",
    "intro": "Reusable named sets of value mappings — typically one per client. Attach any cross-table to a format, or keep the Lab default that every format uses by default.",
    "searchPlaceholder": "Search by name…",
    "createButton": "New cross-table",
    "createTitle": "Create a cross-table",
    "nameLabel": "Name",
    "namePlaceholder": "e.g. MDEQ 2026 codes",
    "created": "Cross-table created and attached to this format.",
    "cloned": "Cloned to “{{name}}”",
    "renamed": "Renamed",
    "deleted": "Deleted “{{name}}”",
    "suggested": "Suggested codes for {{count}} value(s)",
    "saved": "Saved {{count}} mapping(s)",
    "empty": "No cross-tables match your search.",
    "adminsOnlyTitle": "Admins only",
    "adminsOnlyBody": "Cross-tables are managed by admins. Ask an admin for access.",
    "colName": "Name",
    "colValues": "Values",
    "colTables": "Tables",
    "colSource": "Source",
    "colUpdated": "Updated",
    "defaultBadge": "Default",
    "cloneButton": "Clone",
    "cloneTitle": "Clone “{{name}}”",
    "cloneIntro": "Make a copy you can edit without changing the original.",
    "renameTitle": "Rename cross-table",
    "deleteTitle": "Delete cross-table",
    "deleteConfirm": "Delete “{{name}}”? Formats using it revert to the Lab default. This can’t be undone.",
    "editorIntro": "Pick a table, fill in codes, and let AI suggest the rest. Nothing is saved until you click Save.",
    "backToList": "← All cross-tables",
    "tools": {
      "title": "Build & share",
      "intro": "Jumpstart this cross-table from a regulator spec's known codes, import mappings from a CSV, or share with (and pull from) the community.",
      "specLabel": "Jumpstart from a spec",
      "specPlaceholder": "Pick a regulator spec…",
      "jumpstart": "Jumpstart",
      "jumpstarted": "Seeded {{count}} mapping(s) from the spec.",
      "importFile": "Import from CSV",
      "imported": "Imported {{count}} mapping(s) ({{skipped}} row(s) skipped).",
      "regulatorLabel": "Community regulator",
      "share": "Share to community",
      "importCommunity": "Import community codes",
      "shared": "Shared {{count}} mapping(s) to the community.",
      "communityImported": "Imported {{count}} community mapping(s)."
    },
    "tableLabel": "Table",
    "newTableLabel": "Add a table",
    "addTable": "Add",
    "noTables": "This cross-table has no tables yet. Add one to start mapping.",
    "needsCode": "{{count}} value(s) still need a code.",
    "allMapped": "Every value has a code.",
    "suggestButton": "Suggest codes",
    "addValue": "Add value",
    "saveButton": "Save ({{count}})",
    "colElmnt": "Your value",
    "colCode": "Code",
    "colLabel": "Label / CAS",
    "aiSuggests": "AI: {{code}} ({{pct}}%)",
    "accept": "Accept",
    "truncatedHint": "Showing the first {{max}} values in this table.",
    "attachHeading": "Cross-tables",
    "attachIntro": "Tick every cross-table this format should use. They merge top-to-bottom — when two map the same value, the one higher in the list wins. Per-table overrides on this format still win over all of them. Tick none to use the Lab default (your lab's shared mappings).",
    "attachLabel": "Cross-tables for this format",
    "createNewOption": "+ Create new cross-table",
    "createIntro": "Name your new cross-table. It starts empty — add value mappings on the Cross-tables page (or by uploading them below), then it's reusable on any format.",
    "createNameLabel": "Cross-table name",
    "createConfirm": "Create",
    "attached": "Cross-tables updated for this format.",
    "noneYet": "No named cross-tables yet. Create one, or split your Lab default into cross-tables below.",
    "priorityRank": "#{{rank}}",
    "priorityHint": "Higher in the list wins when two cross-tables map the same value. Per-table overrides on this format still win over all of them.",
    "usingLabDefault": "No cross-tables selected — this format uses the Lab default (your lab's shared mappings).",
    "moveUp": "Move {{name}} up",
    "moveDown": "Move {{name}} down",
    "splitButton": "Split Lab default into cross-tables",
    "split": "Created {{count}} cross-table(s) from your Lab default.",
    "acceptAll": "Accept all ({{count}})",
    "aiSuggestsNoPct": "AI: {{code}}",
    "deleteValueTitle": "Delete this mapping?",
    "deleteValueConfirm": "Delete the mapping for “{{value}}”? It’s removed from the saved cross-table and can’t be undone.",
    "editDefaultNote": "Editing the Lab default changes the shared mappings every format uses by default."
  },
  "sadmin": {
    "nav": {
      "allOrgs": "All Organizations"
    },
    "orgs": {
      "pageTitle": "All Organizations",
      "pageSubtitle": "Browse every lab, see its locations, and join any lab to access it.",
      "searchLabel": "Search organizations",
      "searchPlaceholder": "Search by name…",
      "locationCount_one": "{{count}} location",
      "locationCount_other": "{{count}} locations",
      "noOrgs": "No organizations",
      "noOrgsBody": "No organizations have been created yet.",
      "noResults": "No organizations match «{{query}}»",
      "noResultsClear": "Clear search",
      "guardTitle": "Super-admin access required",
      "guardBody": "Only platform super-admins can view all organizations.",
      "defaultLocation": "default",
      "alreadyJoined": "Joined"
    },
    "join": {
      "cta": "Join Lab",
      "title": "Join {{orgName}}",
      "body": "You are joining {{orgName}} as a member. You will be able to switch into this lab and access its formats, data, and generation.",
      "confirm": "Join",
      "success": "You joined {{orgName}}.",
      "alreadyMember": "Already a member"
    },
    "switch": {
      "label": "Active lab",
      "loading": "Loading…",
      "returnToHome": "Return to my lab",
      "notMemberError": "You need to join this lab first."
    },
    "actingIn": {
      "label": "Acting in:",
      "exit": "Exit"
    }
  },
  "org": {
    "noMembershipsError": "You have no lab memberships. Contact your administrator.",
    "labUnavailable": "Your active lab is no longer available. Switched to your home lab.",
    "switcherItemLabel": "Switch to {{org}} ({{role}})"
  },
  "members": {
    "nav": {
      "label": "Members"
    },
    "pageTitle": "Lab Members",
    "pageSubtitle": "Manage who belongs to this lab and their role.",
    "memberCount_one": "{{count}} member in {{orgName}}",
    "memberCount_other": "{{count}} members in {{orgName}}",
    "you": "you",
    "guardTitle": "Admin access required",
    "guardBody": "Only lab admins can manage members. Ask an admin for access.",
    "empty": "No members yet",
    "emptyBody": "Add a member to give them access to this lab.",
    "addMember": "Add Member",
    "cannotRemoveSelf": "You cannot remove yourself from the lab.",
    "lastAdminError": "Cannot remove or demote the only admin. Add another admin first.",
    "loadError": "Couldn't load members. Check your connection and try again.",
    "add": {
      "title": "Add Member",
      "emailLabel": "Email address",
      "emailHint": "Must be an existing Prisma EDD Builder account.",
      "roleLabel": "Role",
      "confirm": "Add Member",
      "success": "{{email}} added to this lab.",
      "alreadyMember": "{{email}} is already a member of this lab.",
      "notFound": "No account found for {{email}}. Ask a super-admin to create one first."
    },
    "remove": {
      "title": "Remove Member",
      "body": "Remove {{email}} from {{orgName}}? They will lose all access to this lab's formats and data.",
      "confirm": "Remove Member",
      "success": "{{email}} removed from this lab."
    },
    "roleChange": {
      "label": "Role for {{email}}",
      "save": "Save role for {{email}}",
      "success": "{{email}} is now a {{role}} in this lab."
    },
    "roles": {
      "admin": "admin",
      "tech": "tech"
    }
  }
}
